<template>
    <div>
        <text-area
            v-model="comment_external"
            :placeholder="$t('applications.hire_comment_external_partner').toString()"
            class="mt-8 mb-16"
        >
            {{ $t('applications.hire_reason_external') }}
        </text-area>
    </div>
</template>
<script>
import PopupModal from "./ui/PopupModal.vue";
import TextArea from "./forms/TextArea.vue";
import * as HireReasonService from "../services/HireReasonService";
import HireReason from "../models/HireReason";
import {normalizeJson} from "../../shared/helpers";
import SelectDropdown from "./forms/SelectDropdown.vue";
import {useRepo} from 'pinia-orm';

export default {
    name: "HireReason",
    components: {SelectDropdown, TextArea, PopupModal},
    props: {
        value: Object,
    },
    computed: {
        reason: {
            get() {
                return this.value.reason;
            },
            set(val) {
                return this.update('reason', val);
            },
        },
        comment: {
            get() {
                return this.value.comment;
            },
            set(val) {
                return this.update('comment', val);
            },
        },
        comment_external: {
            get() {
                return this.value.comment_external;
            },
            set(val) {
                return this.update('comment_external', val);
            },
        },
        reasons() {
            return useRepo(HireReason).orderBy('order').get()
                .map(item => ({
                    label: item.title,
                    value: item.title,
                }));
        },
    },
    methods: {
        update(key, val) {
            let obj = this.value;
            obj[key] = val;
            this.$emit('input', obj);
            return obj;
        },
        fetchReasons() {
            return HireReasonService.index().then(({data}) => {
                return useRepo(HireReason).save(normalizeJson(data));
            });
        },
    },
    mounted() {
        this.fetchingReasons = true;
        this.fetchReasons().then(() => this.fetchingReasons = false);
    },
}
</script>
